import { addMinutes, differenceInMilliseconds, formatRFC3339, isAfter, parseISO } from 'date-fns';

export const calculateExpiry = (minutes: number) =>
  formatRFC3339(addMinutes(getUTCDateTime(), minutes));

export const differenceMsFromNow = (date: string) => {
  const parsedExpiry = parseISO(date);
  return differenceInMilliseconds(parsedExpiry, getUTCDateTime());
};

export const getUTCDateTime = (dateString: string | Date | number = Date.now()) => {
  const date = new Date(dateString);

  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
};

export const isExpired = (date: string) => {
  const parsedDate = parseISO(date);

  return isAfter(getUTCDateTime(), parsedDate);
};
